// extracted by mini-css-extract-plugin
export default {"registrationForm":"RegistrationForm_registrationForm__qHFcI","label":"RegistrationForm_label__nK2+x"};